import { mix } from "polished";
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Poppins", sans-serif;
    letter-spacing: 0.2px;
    outline: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }

  html {
    overflow: hidden;
  }

  body {
    display: block;
    background: ${({ theme }) => theme.background};
    font-size: 14px;
    color: ${({ theme }) => theme.text};
    font-family: sans-serif;
    user-select: none;
    overflow: auto;
    overflow: overlay;
    -webkit-touch-callout: none;
    overscroll-behavior-y: contain;
    height: 100vh;
  }

  html, body {
    overscroll-behavior-y: contain;
  }
  
  ::selection {
    background-color: ${({ theme }) => theme.primary};
    color: white;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => mix(0.7, theme.background, theme.text)};
    border: 2px solid rgba(0,0,0,0);
    border-radius: 10px;
    background-clip: padding-box;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.primary};
  }

  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }

  [hidden] {
    display: none !important;
  }

  [data-scrollbar-hidden~="true"] {
    scrollbar-width: none;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
      
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: ${({ theme }) => theme.text};
    box-shadow: 0 0 0 30px ${({ theme }) => theme.primary} inset !important;
  }

  hr {
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.border};
  }

  img {
    position: relative;
    overflow: hidden;
  }

  img, a {
    -webkit-user-drag: none;
    user-drag: none;
  }

  img::before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: #4f4f4f;
    background-image: url(/images/no-image.svg);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

export default GlobalStyles;
